<template>
  <div
    class="p-grid p-jc-center p-ac-center"
    style="padding:50px;height:600px;background:#a5d3f7"
  >
    <div class="p-col-12 p-md-6 p-lg-4">
      <Card>
        <template slot="header">
          <ProgressBar
            mode="indeterminate"
            style="height: 1px"
            v-if="loading"
          />
        </template>
        <template slot="content">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-lock"></i>
            </span>
            <span class="p-float-label">
              <InputText
                id="password"
                :type="typeSelect?'password':'text'"
                v-model.trim="password"
              />
              <label for="password">Password Actual</label>
              <Button icon="pi pi-eye" @click="typeSelect=!typeSelect" name="mostrar"/>
            </span>
          </div>
          <div class="p-inputgroup p-mt-5">
            <span class="p-inputgroup-addon">
              <i class="pi pi-lock"></i>
            </span>
            <span class="p-float-label">
              <InputText
                id="newPassword"
                :type="typeSelect?'password':'text'"
                v-model.trim="newPassword"
              />              
              <label for="newPassword">Nuevo Password</label>
              <Button icon="pi pi-eye" @click="typeSelect=!typeSelect" name="mostrar"/>
            </span>
          </div>          
          <span class="errorLabel" v-show="newPassword.length<8">El password debe ser de más de 8 caracteres</span>
          <div class="p-inputgroup p-mt-5">
            <span class="p-inputgroup-addon">
              <i class="pi pi-lock"></i>
            </span>
            <span class="p-float-label">
              <InputText
                id="rePassword"
                :type="typeSelect?'password':'text'"
                v-model.trim="rePassword"
                :class="{'p-invalid':rePassword!=newPassword}"
              />
              <label for="rePassword">Confirmación de Nuevo Password</label>
              <Button icon="pi pi-eye" @click="typeSelect=!typeSelect" name="mostrar"/>
            </span>
          </div>
          <span class="errorLabel" v-show="newPassword!=rePassword">Debe ser igual al nuevo password</span>
        </template>
        <template slot="footer">
          <Button
            label="Cambiar password"
            @click="cambiarPassword()"
            :loading="loading"
             name="guardar"
          />
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import AuthService from "../service/auth.service";
export default {
  metaInfo: {
    title: 'Change Password - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Change Password - QualityCare',
        content: 'Sitio para cambiar el password',
      },
    ],
  },
  data() {
    return {
      authService: null,
      password: "",
      newPassword: "",
      rePassword: "",
      loading: false,
      typeSelect:true
    };
  },
  created() {
    this.authService = new AuthService();
  },
  methods: {
    ...mapMutations(['setChangePassword']),
    cambiarPassword() {
      this.loading = true;
      if (
        this.newPassword.length<8 || this.newPassword.indexOf(' ')!=-1
      ) {
        this.$toast.add({
          severity: "warn",
          summary: "Error",
          detail: "El password debe tener por lo menos 8 caracteres, sin espacios",
          life: 3000,
        });
        this.loading = false;
        return false;
      }
      if (
        this.newPassword == "" ||
        this.password == "" ||
        this.rePassword == ""
      ) {
        this.$toast.add({
          severity: "warn",
          summary: "Error",
          detail: "Debes completar todos los campos",
          life: 3000,
        });
        this.loading = false;
        return false;
      }
      if (this.newPassword != this.rePassword) {
        this.$toast.add({
          severity: "warn",
          summary: "Error",
          detail: "El password nuevo y su confirmación deben ser identicos",
          life: 3000,
        });
        this.loading = false;
        return false;
      }
      const data = {
        password: this.password,
        new_password: this.newPassword,
      };
      this.authService.cambiarPassword(data)
      .then((result) => {
          if (!result.data.data) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error al guardar el nuevo password",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Felicidades",
              detail: "El password se guardó satisfactoriamente",
              life: 3000,
            });
            this.setChangePassword(0)
            this.$router.push({ name: "main" });            
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al acceder contacte al proveedor",
            life: 3000,
          });
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.errorLabel{
  font-size: 12px;
  color: #e00000;
}
</style>
